module.exports = __webpack_public_path__ + "static/media/np-logo.a8915a4d.png";